import assetTypeService from "../../../../services/assetService/assetTypeService";
import { CACHE_KEY_ASSETTYPES } from "../../../../utils/constants";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AssetTypeInterface } from "../../../../models/AssetModel/AssetType";

interface DeleteAssetTypeContext {
  previousAssetTypes: AssetTypeInterface[];
  deletedAssetType: AssetTypeInterface | undefined;
}

const useDeleteAssetType = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    void, // No return data after deletion
    Error,
    string, // ID of the category to delete
    DeleteAssetTypeContext
  >({
    mutationFn: assetTypeService.Remove, // Remove should take a string ID

    onMutate: (assetTypeId: string) => {
      const previousAssetTypes =
        queryClient.getQueryData<AssetTypeInterface[]>([
          CACHE_KEY_ASSETTYPES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ]) || [];

      // Optimistically update the cache
      queryClient.setQueryData<AssetTypeInterface[]>(
        [
          CACHE_KEY_ASSETTYPES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        previousAssetTypes.filter((assetType) => assetType.id !== assetTypeId) // Use assetTypeId to filter
      );

      return {
        previousAssetTypes,
        deletedAssetType: previousAssetTypes.find(
          (assetType) => assetType.id === assetTypeId
        ),
      };
    },

    onError: (error, assetTypeId, context) => {
      if (!context) return;

      // Rollback to the previous state in case of error
      queryClient.setQueryData<AssetTypeInterface[]>(
        [
          CACHE_KEY_ASSETTYPES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        context.previousAssetTypes
      );
    },

    onSuccess: () => {
      // Optionally, you could perform additional actions on success
      // For example, invalidating queries or updating other parts of the state
    },
  });
};

export default useDeleteAssetType;
